
import * as handlebars_family from "../handlebars_family.ts";
import "../layout/layout_modal.mustache";
const TPL = handlebars_family.addTemplate("mealplanner/modal_export",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"modal V4 large mp-export\"><div class=\"title\"><icon class=\"modal-close\" data-fw-onclick=\"modalclose\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_close",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":138},"end":{"line":1,"column":160}}}))
    + "</icon><span class=\"mp-export-title\"></span></div><flexrow class=\"mp-export-steps\"></flexrow><div class=\"content mp-export-body\"></div><flexrow class=\"mp-export-footer\"><button type=\"button\" class=\"secondary mp-export-back\" data-fw-onclick=\"mpexportback\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.back",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":415},"end":{"line":1,"column":440}}})) != null ? stack1 : "")
    + "</button><button type=\"button\" class=\"line mp-export-next\" data-fw-onclick=\"mpexportnext\"></button></flexrow></div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_modal"),depth0,{"name":"layout/layout_modal","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " ";
},"usePartial":true,"useData":true});
export default TPL;